// extracted by mini-css-extract-plugin
export default {"Title":"VisitsToday_Title__K9HO-","CardRow":"VisitsToday_CardRow__Bk3hh"};